import React, {useEffect} from 'react'
import {Formik} from 'formik';
import Button from './Button';
import PropTypes from 'prop-types'
import {setForm} from 'redux/actions'
import {connect} from 'react-redux'
import ValidationShema from "../constants/ValidationShema";

function InnerForm(
    {
        id,
        htmlFormId,
        setForm,
        formikProps,
        submitLabel,
        children,
        className,
        afterSubmitFunc = () => {
        },
    }) {

    useEffect(() => {
        if (id !== undefined) {
            // setForm(id, formikProps.submitForm)
            setForm(id, () => {
                formikProps.submitForm().then(afterSubmitFunc)
            })
            setForm(id + "_reset", formikProps.resetForm)
        }
        return () => {
            if (id !== undefined) {
                setForm(id);
                setForm(id + "_reset");
            }
        }
        // eslint-disable-next-line
    }, [])

    return (
        <form
            id={htmlFormId}
            style={{width: "100%"}}
            autoComplete="off"
            className={className}
            onSubmit={formikProps.handleSubmit}
        >
            {children(formikProps)}
            {submitLabel &&
                <Button type="submit">
                    {submitLabel}
                </Button>
            }
        </form>
    )
}

function Form(
    {
        children,
        onSubmit,
        onReset,
        submitLabel,
        initialValues,
        initialTouched,
        validationSchema = ValidationShema.any(),
        id,
        htmlFormId,
        setForm,
        className,
        afterSubmitFunc,
        onChange,
        validateOnMount,
        validateOnChange,
        validateOnBlur
    }) {

    useEffect(() => {
        return () => {
            setForm(id)
        };
        // eslint-disable-next-line
    }, [])

    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            initialTouched={initialTouched}
            onChange={onChange}
            validateOnMount={validateOnMount}
            validateOnChange={validateOnChange}
            validateOnBlur={validateOnBlur}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false);
                onSubmit(values, actions)
            }}
            onReset={onReset}
        >{(props) => (<InnerForm
            afterSubmitFunc={afterSubmitFunc}
            className={className}
            formikProps={props}
            id={id}
            htmlFormId={htmlFormId}
            setForm={setForm}
            submitLabel={submitLabel}
            children={children}
        />)}</Formik>
    )
}

Form.propTypes = {
    id: PropTypes.string,
    htmlFormId: PropTypes.string,
    initialValues: PropTypes.any,
    submitLabel: PropTypes.any,
    onSubmit: PropTypes.func,
    onReset: PropTypes.func,
    validationSchema: PropTypes.object,
    className: PropTypes.string,
}

Form.defaultProps = {
    onSubmit: () => {
    },
    initialValues: {},
    validationSchema: {},
}

export default connect((state) => ({}), {
    setForm
})(Form);
